import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import OntraccrPopconfirm from '../../../../common/modals/OntraccrPopconfirm';
import Colors from '../../../../constants/Colors';
import { formatProjectLabelFromCompanySettings } from '../../../../projects/projectHelpers';

export default function TimeTrackingGridColumnTitle({
  project,
  phase,
  costcode,
  responding,
  onDelete,
  isUnassigned = false,
  settings = {},
}) {
  const projectLabel = project
    ? formatProjectLabelFromCompanySettings({ ...project, settings })
    : null;

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: 5 }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {projectLabel && <span className="time-tracking-grid-project">{projectLabel}</span>}
        {phase?.name && <span className="time-tracking-grid-phase">{phase.name}</span>}
        <span
          className={[
            'time-tracking-grid-costcode',
            isUnassigned && 'time-tracking-grid-costcode-unassigned',
          ].filter(Boolean).join(' ')}
        >
          {costcode?.fullText || 'Unassigned'}
        </span>
      </div>
      {responding && (
        <OntraccrPopconfirm
          title="Are you sure you want to delete this cost code and all associated hours?"
          onConfirm={onDelete}
          okText="Delete"
          cancelText="Cancel"
        >
          <div className="time-tracking-grid-column-title-delete-button">
            <DeleteOutlined
              style={{ color: Colors.ONTRACCR_RED, cursor: 'pointer', marginLeft: 8 }}
            />
          </div>
        </OntraccrPopconfirm>
      )}
    </div>
  );
}

TimeTrackingGridColumnTitle.propTypes = {
  project: PropTypes.shape({
    name: PropTypes.string,
  }),
  phase: PropTypes.shape({
    name: PropTypes.string,
  }),
  costcode: PropTypes.shape({
    fullText: PropTypes.string,
  }),
  settings: PropTypes.shape({}),
  responding: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
  isUnassigned: PropTypes.bool,
};

TimeTrackingGridColumnTitle.defaultProps = {
  isUnassigned: false,
  project: null,
  phase: null,
  costcode: null,
  responding: false,
};
